// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.scss\"","crimsonColor":"#ce3636","button":"ForgotPasswordForm_button__2_LEx","error":"ForgotPasswordForm_error__3IDLu"};